<template>
    <div>
        <v-container fluid class="tags">
            <v-row>
                <v-col>
                    <v-card class="content-card my-4">
                        <v-card-title>
                            <v-text-field
                                @click.native.stop
                                v-model="search"
                                placeholder="Search"
                                prepend-inner-icon="search"
                                single-line
                                hide-details
                                style="width: 15px;"
                                color="primary"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" class="white--text" @click="showCreateTagModal()"><v-icon class="button-icon">add</v-icon>Create </v-btn>
                        </v-card-title>
                        <v-data-table :headers="headers" :items-per-page="1000" :items="tags" :search="search" class="elevation-1">
                            <template v-slot:item="props">
                                <tr class="tags-row">
                                    <td class="text-xs-center">
                                        {{ props.item.id }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.key_en }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.key_gr }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.name_en }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.name_gr }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.only_for_search }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.generic_key }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.is_main }}
                                    </td>
                                    <td class="text-xs-left">
                                        {{ props.item.relative_tag_ids }}
                                    </td>
                                    <td class="text-xs-center px-0">
                                        <v-icon small class="px-1" @click="showEditTagModal(props.item)">edit</v-icon>
                                        <v-icon small class="px-1" @click.stop="showDeleteTagModal(props.item)">delete</v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog id="tagEditDialog" v-model="showTagEdit" width="700" overlay-opacity="0.9" :fullscreen="$vuetify.breakpoint.xsOnly" @click:outside="showTagEdit = false">
            <edit-tag :mode="selectedMode" :tag="selectedTag" @hide="showTagEdit = false"></edit-tag>
        </v-dialog>
        <v-dialog id="tagDeleteDialog" v-model="showTagDelete" width="500" overlay-opacity="0.9" @click:outside="showTagDelete = false">
            <v-card class="tag-delete-dialog-card">
                <v-card-title>Are you sure?</v-card-title>
                <v-card-actions class="d-flex justify-end">
                    <v-btn color="error" elevation="1" @click="deleteTag()">
                        Delete
                    </v-btn>
                    <v-btn elevation="1" @click="showTagDelete = false">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as R from 'ramda';
import { mapMutations } from 'vuex';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';
import { BusinessOptionsApi } from '@/api';
import { EditTag } from '@/components';

export default {
    name: 'Tags',
    components: { EditTag },
    data: () => ({
        search: '',
        tags: [],
        headers: [
            {
                text: 'id',
                align: 'left',
                sortable: true,
                value: 'id',
                width: '5%',
            },
            {
                text: 'key_en',
                align: 'left',
                sortable: false,
                value: 'key_en',
                width: '10%',
            },
            {
                text: 'key_gr',
                align: 'left',
                sortable: false,
                value: 'key_gr',
                width: '10%',
            },
            {
                text: 'name_en',
                align: 'left',
                sortable: false,
                value: 'name_en',
                width: '10%',
            },
            {
                text: 'name_gr',
                align: 'left',
                sortable: false,
                value: 'name_gr',
                width: '10%',
            },
            {
                text: 'only_for_search',
                align: 'left',
                sortable: true,
                value: 'only_for_search',
                width: '10%',
            },
            {
                text: 'generic_key',
                align: 'left',
                sortable: true,
                value: 'generic_key',
                width: '10%',
            },
            {
                text: 'is_main',
                align: 'left',
                sortable: true,
                value: 'is_main',
                width: '10%',
            },
            {
                text: 'relative_tag_ids',
                align: 'left',
                sortable: true,
                value: 'relative_tag_ids',
                width: '10%',
            },
            {
                text: 'Actions',
                value: '',
                align: 'left',
                sortable: false,
                width: '10%',
            },
        ],
        showTagEdit: false,
        selectedTag: null,
        selectedMode: 'create',
        showTagDelete: false,
        tagToDelete: null,
    }),
    created() {
        this.loadData();
    },
    methods: {
        ...mapMutations('BusinessOptions', {
            setTagsMutation: 'setTagsMutation',
            deleteTagMutation: 'deleteTagMutation',
        }),
        async loadData() {
            const { data: items } = await BusinessOptionsApi.getTags();
            this.tags = items;
            this.setTagsMutation(this.tags);
        },
        showCreateTagModal() {
            this.selectedMode = 'create';
            this.selectedTag = {
                key_en: null,
                key_gr: null,
                name_en: null,
                name_gr: null,
                only_for_search: false,
                generic_key: null,
                is_main: false,
                relative_tag_ids: null,
            };
            this.showTagEdit = true;
        },
        showEditTagModal(tag) {
            this.selectedMode = 'edit';
            this.selectedTag = R.clone(tag);
            this.showTagEdit = true;
        },
        showDeleteTagModal(tag) {
            this.tagToDelete = tag;
            this.showTagDelete = true;
        },
        async deleteTag() {
            await BusinessOptionsApi.deleteTag(this.tagToDelete['id']);
            this.deleteTagMutation(this.tagToDelete);
            this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Tag deleted successfully', color: 'success' });
            this.tagToDelete = null;
            this.showTagDelete = false;
        },
    },
};
</script>

<style lang="scss">
.tags {
    .action-card {
        padding: 1rem;

        .v-text-field {
            padding-top: 0;
            margin-top: 8px;
        }

        .v-input__slot {
            margin-bottom: 0;
        }

        .button-icon {
            margin-right: 5px;
        }
    }

    .content-card {
        .tag-row {
            cursor: pointer;
        }
    }

    .text-field {
        margin: 5px;
    }
}
</style>
